var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.isNotFound)?[_c('PageNotFound')]:[_c('main',{staticClass:"ws-page"},[(!_vm.isLoading)?_c('ws-study-groups-list',{attrs:{"org":_vm.org}}):_vm._e()],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }